<div class="slat-assessment-main-view-card-header">
  <app-header-bar
    (routerLinkClick)="cancelAssessment()"
    [age]="_age"
    [dob]="_dateOfBirth"
    [showButton]="false"
    [showClientDetails]="_showClientDetails"
    [title]="_clientName"
    *ngIf="_dateOfBirth != undefined || _dateOfBirth != null"
  ></app-header-bar>
</div>
<!-- Client Information -->
<div class="dashboard-side-card-container">
  <app-client-information
    id="client-information"
    subtitle=""
    [title]="_clientInformationTitle"
    [urlDisplayText]="_clientInformationDisplayText"
    [url]="_clientInformationUrl"
    [attributes]="_clientInformationAttributes"
    [isVertialOrientation]="true"
  />
</div>
<!-- Sub-Menu -->
<app-sub-menu
  [clientId]="_clientId"
  [totalReviews]="_totalReviews"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [showBackButton]="true"
  (navigateBackClick)="previousRoute()"
/>
<div class="slat-assessment-page-layout">
  <div class="slat-assessment-page-left">
    <div class="slat-assessment-content">
      <app-primary-card size="full" class="slat-assessment-primary-card">
        <app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
        <div id="graph-header" class="header">
          <div id="header-title" class="mat-headline-2">
            {{ 'SLAT Details' | translate }}
          </div>
          <app-action-toolbar
            [isEdit]="true"
            (editClick)="navigateTo('editSlat')"
            [isFullView]="false"
            (fullViewClick)="navigateTo('fullViewSlat')"
            [isHistory]="true"
            (historyClick)="navigateTo('historySlat')"
            [isReport]="false"
            (reportClick)="navigateTo('reportSlat')"
            [isNew]="true"
            (newClick)="navigateTo('newSlat')"
          />
        </div>
        <div class="slat-assessment-info">
          <app-table-multi-header
            [dataSource]="dataSource"
            [isEdit]="false"
            [isView]="true"
            [isAdd]="false"
            [isTableHeaderVisible]="false"
            class="app-slat-table"
          ></app-table-multi-header>
        </div>
      </app-primary-card>
    </div>
  </div>
  <div class="slat-assessment-page-right">
    <div class="slat-assessment-side-card">
      <app-side-card height="940" size="full">
        <H1>{{ 'SLAT' | translate }}</H1>
        <div class="section">
          <div class="title">{{ 'Data entered by' | translate }}</div>
          <div>
            <span class="text-highlight">{{ _soundEnteredByName }}</span>
          </div>
        </div>
        <div class="section">
          <div class="title">{{ 'Assessment Date' | translate }}</div>
          <div class="text-highlight">{{ _presentationDate }}</div>
        </div>
        <div class="section">
          <div class="title">{{ 'Template' | translate }}</div>
          <div class="text-highlight">{{ _templateName }}</div>
        </div>
        <div class="section">
          <div class="title">{{ 'Considerations' | translate }}</div>
          <div *ngFor="let consideration of _considerations; let i = index">
            <input type="checkbox" checked aria-hidden="true" /><span
              class="text"
              >{{ consideration | translate }}</span
            >
          </div>
          <div *ngIf="_considerations.length === 0" class="text">
            {{ 'None Selected' | translate }}
          </div>
        </div>

        <div class="notes-section">
          <div class="title">
            <div class="title">{{ 'Session Notes' | translate }}</div>
            <div class="text">{{ _notes }}</div>
          </div>
        </div>
      </app-side-card>
    </div>
  </div>
</div>
